module.exports = __webpack_public_path__ + "static/media/mobile-view-logo.f5c8d862.png";